import { Button, BUTTON_VARIANT } from "components/UI/Button";
import { HelpCircle } from "components/UI/Icons";
import { Tooltip } from "components/UI/Tooltip";
import { ARROW_POSITION, TooltipContent } from "components/UI/Tooltip";
import { useTranslation } from "localization/localization";
import { PackageSettingsLayoutProps } from "./PackageSettings.types";
import s from "./PackageSettings.module.scss";

export const PackageSettingsLayout = ({
  spacingContent,
  stuffingContent,
  onClose,
  onSave,
}: PackageSettingsLayoutProps) => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <div className={s.columns}>
        <div className={s.columnSpacing}>
          <div className={s.titleBox}>
            <h3 className={s.title}>{t("Spacing settings")}</h3>
            <Tooltip
              triggerElement={<HelpCircle className={s.helpCircle} />}
              offsetY={10}
              offsetX={-20}
              placement="bottom"
              enabledOnMobile={true}
            >
              <TooltipContent className={s.tooltipContent} arrowPosition={ARROW_POSITION.TOP}>
                {t("Click on the checkbox if you allow tilt width or length")}
              </TooltipContent>
            </Tooltip>
          </div>

          <div className={s.spacingContent}>{spacingContent}</div>
        </div>
        <div className={s.columnStuffing}>
          <div className={s.titleBox}>
            <h3 className={s.title}>{t("Stuffing settings")}</h3>
            <Tooltip
              triggerElement={<HelpCircle className={s.helpCircle} />}
              offsetY={10}
              offsetX={-20}
              placement="bottom"
              enabledOnMobile={true}
            >
              <TooltipContent className={s.tooltipContent} arrowPosition={ARROW_POSITION.TOP}>
                {t("Specify the parameters of the allowable load that can be placed on top")}
              </TooltipContent>
            </Tooltip>
          </div>

          <div className={s.stuffingContent}>{stuffingContent}</div>
        </div>
      </div>
      <div className={s.actions}>
        <Button variant={BUTTON_VARIANT.SECONDARY} onClick={onClose}>
          {t("Cancel")}
        </Button>
        <Button className={s.save} onClick={onSave}>
          {t("Save")}
        </Button>
      </div>
    </div>
  );
};
